import React from "react";
import "../styles/povertyCycle.css";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";
import { useRef } from "react";

const steps = [
  { text: "Interrupted schooling\n(Unpaid fees)", type: "normal" },
  { text: "Poor grades\n(Not true potential)", type: "normal" },
  { text: "Missed higher education\n(scholarships)", type: "normal" },
  { text: "Low paying opportunities\n& early marriage", type: "normal" },
  { text: "Poverty at home\n(Unstable income)", type: "normal" },
  { text: "Next generation at risk", type: "normal" },
  { text: "TUWE Initiative\nBreaks the cycle", type: "tuwe" },
];

const PovertyCycle = () => {
  const isDesktop = useMediaQuery({ minWidth: 768 });

  // ✅ Adjust size and radius based on screen
  const size = isDesktop ? 600 : 320;
  const radius = isDesktop ? 240 : 135;
  const center = size / 2;

  // Arc settings (~300°)
  const ARC = Math.PI * 1.7; // 300°
  const START_ANGLE = -Math.PI / 2; // Start at top

  // Calculate positions
  const positions = steps.map((_, index) => {
    const t = index / (steps.length - 1);
    const angle = START_ANGLE + t * ARC;

    return {
      x: center + radius * Math.cos(angle),
      y: center + radius * Math.sin(angle),
    };
  });

     const servicesRef = useRef(null);
      
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

  return (
    <div className="cycle-main-wrapper" ref={servicesRef}>
    <div className="cycle-wrapper">
      <h2 className="title" data-reveal>
     
        <span>Breaking the vicious cycle of poverty</span>
      </h2>

      <div className="cycle-container" style={{ width: size, height: size }} data-reveal>
        {/* SVG arrows */}
        <svg
          className="cycle-arrows"
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
        >
          <defs>
            <marker
              id="arrow"
              markerWidth="10"
              markerHeight="10"
              refX="6"
              refY="3"
              orient="auto"
            >
              <path d="M0,0 L0,6 L9,3 z" fill="#9aa0a6" />
            </marker>
          </defs>

          {positions.map((pos, index) => {
            if (index === positions.length - 1) return null;
            const next = positions[index + 1];
            return (
              <path
                key={index}
                d={`M ${pos.x} ${pos.y} A ${radius} ${radius} 0 0 1 ${next.x} ${next.y}`}
                fill="none"
                stroke="#9aa0a6"
                strokeWidth="2"
                markerEnd="url(#arrow)"
              />
            );
          })}
        </svg>

        {/* Steps */}
        {steps.map((step, index) => (
          <div
            key={index}
            className={`cycle-item ${step.type === "tuwe" ? "tuwe-item" : ""}`}
            style={{
              left: `${positions[index].x}px`,
              top: `${positions[index].y}px`,
              transform: "translate(-50%, -50%)", // center the text
            }}
          >
            {step.text}
          </div>
        ))}
      </div>
    </div>
    </div>

  );
};

export default PovertyCycle;
